import { observer } from 'mobx-react-lite';
import type { RightSideCanvasStore } from '../../../components/RightSideCanvas/store';
import { BiDashboardPageController } from '../../BiDashboard';

import { ErrorBoundary } from '../../../components/ErrorBoundary/index.ts';
import type { AiRightSideCanvasObject } from '../../AiReferencedObjectCard';
import { BiMetricPageController } from '../../BiMetric/BiMetricPageController.tsx';

const AiRightSideDisplayInternal = observer(
	({ store }: { store: RightSideCanvasStore<AiRightSideCanvasObject> }) => {
		const rightSideDisplay = store.pageSideCanvasMode;
		if (
			rightSideDisplay.mode === 'show' &&
			rightSideDisplay.objectToShow.type === 'bi_metric'
		) {
			return (
				<BiMetricPageController
					metricId={rightSideDisplay.objectToShow.biMetricId}
					closeCanvas={() => {
						store.setPageSideCanvasMode({
							mode: 'hide',
						});
						store.rightSidebarStore.setCollapsed(true);
					}}
					navigateToDashboardInCanvas={(id: string) => {
						store.setPageSideCanvasMode({
							mode: 'show',
							objectToShow: {
								type: 'bi_dashboard',
								biDashboardId: id,
							},
						});
					}}
					mode="canvas"
				/>
			);
		}

		if (
			rightSideDisplay.mode === 'show' &&
			rightSideDisplay.objectToShow.type === 'bi_dashboard'
		) {
			return (
				<BiDashboardPageController
					id={rightSideDisplay.objectToShow.biDashboardId}
					mode="canvas"
					onCloseCanvas={() => {
						store.setPageSideCanvasMode({
							mode: 'hide',
						});
						store.rightSidebarStore.setCollapsed(true);
					}}
					onMetricHeaderClick={(metricId) => {
						store.setPageSideCanvasMode({
							mode: 'show',
							objectToShow: {
								type: 'bi_metric',
								biMetricId: metricId,
							},
						});
					}}
				/>
			);
		}

		return null;
	}
);

export function AiRightSideDisplay(props: {
	store: RightSideCanvasStore<AiRightSideCanvasObject>;
}) {
	return (
		<ErrorBoundary>
			<AiRightSideDisplayInternal {...props} />
		</ErrorBoundary>
	);
}
